/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Validator utilities functions
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */
import isURL from 'validator/es/lib/isURL';

/**
 * Check internal react & gate routes
 * @param internalUrl
 */
export const checkInternalUrlIsValid = (internalUrl: string): boolean =>
    // eslint-disable-next-line
    location && isURL('https://' + location.host + internalUrl, { require_tld: false })
